import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
    Animations,
    BackendOberflaecheService,
    ModalService,
    NeoskopBrokerContactService,
    ProgressManagerService,
    SidebarService,
    StandardBeitragComponent,
    WiedereinsprungLadenResponse,
    WiedereinsprungService,
} from '@vhv/tarifrechner-common';
import { FormBuilder } from '@angular/forms';

@Component({
    animations: [Animations.slideInDownAnimation],
    templateUrl: './start.component.html',
})

export class StartComponent extends StandardBeitragComponent {

    private vermittlernummer: string = '';
    private azvm: string = '';
    private wiedereinsprungDatenSerialisiert: string = '';
    private wiedereinsprungGetriggert = false;
    private azvm_feld: string = '';

    constructor(
        private readonly _inputRouter: Router,
        private readonly _inputRoute: ActivatedRoute,
        private readonly _inputBackendOberflaecheService: BackendOberflaecheService,
        private readonly sidebarService: SidebarService,
        private readonly wiedereinsprungService: WiedereinsprungService,
        private readonly modalService: ModalService,
        private readonly neoskopBrokerContactService: NeoskopBrokerContactService
    ) {
        super();

        this._inputRoute.queryParams.subscribe((params: Record<string, string>) => {
            for (const param in params) {
                if (!params.hasOwnProperty(param)) {
                    continue;
                }

                const paramLowerCase = param.toLowerCase();

                // Lese URL-Parameter case-insensitiv aus
                if ('ivmnr' === paramLowerCase) {
                    this.vermittlernummer = params[param];
                } else if ('azvm' === paramLowerCase) {
                    this.azvm = params[param];
                } else if ('wiedereinsprung' === paramLowerCase) {
                    this.wiedereinsprungDatenSerialisiert = params[param];
                } else if ('azvm_feld' === paramLowerCase) {
                    this.azvm_feld = params[param];
                }
            }
            this._inputRouter.navigate([],{replaceUrl:true, relativeTo:this._inputRoute})
        });
    }

    private anzeigeAZVMEingabeFeld(azvmFeldParameter: string) {
        if (azvmFeldParameter) {
            if (this._inputBackendOberflaecheService.getElementByName('Azvm')) {
                this._inputBackendOberflaecheService.getElementByName('Azvm').attribut.sichtbarkeit = 'immer';
                this._inputBackendOberflaecheService.getElementByName('AzvmSVBestatigungAbstand').attribut.sichtbarkeit = 'immer';
            }
            if (this._inputBackendOberflaecheService.getElementByName('Azvm_Anzeige')) {
                this._inputBackendOberflaecheService.getElementByName('Azvm_Anzeige').value = 'true';
            }
        }
    }

    initialiseSeite() {
        super.initialiseSeite();

        this._inputBackendOberflaecheService.getOberflaeche()
            .then(() => {
                this.handleVermittler();

                if (this.wiedereinsprungDatenSerialisiert) {
                    this.handleWiedereinsprung();
                }
            });
    }

    public handleVermittler() {
        const vermittlernummerElement = this._inputBackendOberflaecheService.getElementByName('Vermittlernummer');

        if (this.vermittlernummer) {
            // Falls gegeben, schreibe Vermittlernummer aus der URL ins OberflaecheElement
            vermittlernummerElement.value = this.vermittlernummer;
        } else if (vermittlernummerElement.value) {
            // Andernfalls, kommt man durch den Zurück-Button wieder auf die erste Seite, gelten die Daten, die im Vermittlernummer-Element stehen
            this.vermittlernummer = vermittlernummerElement.value;
        }

        if (this.vermittlernummer) {
            // Bei gegebener Vermittlernummer, zeige Kontakt-Info an
            this.neoskopBrokerContactService.zeigeVermittlerKontaktInfo(this.vermittlernummer);
        } else {
            // Andernfalls zeige die normalen Kontaktdaten an
            this.sidebarService.zeigeStandardKontaktdaten();
        }

        if (this.azvm) {
            const azvmElement = this._inputBackendOberflaecheService.getElementByName('Azvm');
            azvmElement.value = this.azvm;
        }

        this.anzeigeAZVMEingabeFeld(this.azvm_feld);
    }


    onSubmit(): void {
        super.onSubmit();
        window.addEventListener('beforeunload', StartComponent.createMessageBeforeUnload);
    }

    // Wiedereinsprung kann Vermittlernummer beeinhalten, in diesem Fall zeige die Kontaktdaten an
    private checkVermittler(response:WiedereinsprungLadenResponse):void {
        if ('Vermittlernummer' in response.wiedereinsprungDaten) {
            const wiederhergestellteVermittlernummer = response.wiedereinsprungDaten.Vermittlernummer;

            const vermittlernummerElement = this._inputBackendOberflaecheService.getElementByName('Vermittlernummer');
            this.vermittlernummer = vermittlernummerElement.value = wiederhergestellteVermittlernummer;

            if (wiederhergestellteVermittlernummer) {
                this.neoskopBrokerContactService.zeigeVermittlerKontaktInfo(wiederhergestellteVermittlernummer);
            }
        }
    }

    //Wiedereinsprung kann die Anzeige des Azvm-Felds enthalten, dann muss dieses angezeigt werden
    private checkAzvmFeld(response:WiedereinsprungLadenResponse):void {
        if ('Azvm_Anzeige' in response.wiedereinsprungDaten) {
            this.anzeigeAZVMEingabeFeld(response.wiedereinsprungDaten.Azvm_Anzeige);
        }
    }

    private handleWiedereinsprung() {
        // handleWiedereinsprung wird aus irgendeinem Grund mehrfach getriggert, fange Mehrfachaufrufe ab
        if (this.wiedereinsprungGetriggert) {
            return;
        }

        this.wiedereinsprungGetriggert = true;

        this.wiedereinsprungService.ladeWiedereinsprungDaten(this.wiedereinsprungDatenSerialisiert)
            .then((response: WiedereinsprungLadenResponse) => {
                // Check ob der Link abgelaufen ist
                if (response.linkAbgelaufen) {
                    this.modalService.showDialog(
                        'Diese Daten existieren nicht',
                        'Die von Ihnen gesicherten Daten sind nicht mehr gültig. Bitte geben Sie Ihre Daten erneut ein.'
                    );

                    return;
                }

                this.checkVermittler(response);
                this.checkAzvmFeld(response);

                // Im modalen Dialog wird gefragt, ob der Kunde mit den wiederhergestellten Daten fortsetzen will
                this.modalService.keepOnAnswerSubject.subscribe((value: string) => {
                    // Übernehme wiederhergestellte Daten, wenn der Kunde das anklickt
                    if (value !== 'keepIt') {
                        return;
                    }

                    this.wiedereinsprungService.stelleDatenWiederHer(
                        response.wiedereinsprungDaten,
                        this.viewValidationAdapter
                    );
                });

                this.modalService.showPanel('wiedereinsprungFortsetzen', false);
            })
            .catch((reason: any) => {
                console.error(reason);
                this.modalService.showDialog(
                    'Fehler',
                    'Ihre Eingaben konnten nicht wiederhergestellt werden. Bitte geben Sie Ihre Daten erneut ein. Wir entschuldigen uns für die Unannehmlichkeit.'
                );
            });

    }

    /**
     * Verhindert, dass der Nutzer die Seite verlassen kann, ohne eine Meldung zu bestätigen
     */
    public static createMessageBeforeUnload(e: BeforeUnloadEvent) {
        e.preventDefault();
        e.returnValue = 'Bitte bestätigen Sie, dass Sie die Seite verlassen möchten – Daten, die Sie eingegeben haben, werden unter Umständen nicht gespeichert.';
    }

}
